import React from "react";
import { ListItem, ListItemText, ListItemIcon, Checkbox, Chip } from "@mui/material";
import CategoryListItemContainer from "../CategoryListItemStyles";

const RegionsSideBarListItem = ({ category, handleToggle, checked }) => {
  const handleClick = () => {
    handleToggle(category);
  };
  return (
    <CategoryListItemContainer
      component={ListItem}
      role="listitem"
      onClick={handleClick}
      button={true}
      className="compactSelectableItem"
      disabled={category.members.length === 0}
    >
      <ListItemIcon className="check_box">
        <Checkbox checked={checked} tabIndex={-1} disableRipple />
      </ListItemIcon>
      <ListItemText
        id={category.id}
        primary={category.name}
        primaryTypographyProps={{ variant: "body2" }}
      />
      {category.members.length === 0 && (
        <Chip
          key={category.id}
          label="No R&D Members Exist"
          size="small"
          sx={{ fontWeight: 520, mr: 1 }}
        />
      )}
    </CategoryListItemContainer>
  );
};

export default RegionsSideBarListItem;
